/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The TagsidTag model module.
 * @module model/TagsidTag
 * @version v0.3
 */
export default class TagsidTag {
  /**
   * Constructs a new <code>TagsidTag</code>.
   * @alias module:model/TagsidTag
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TagsidTag</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TagsidTag} obj Optional instance to populate.
   * @return {module:model/TagsidTag} The populated <code>TagsidTag</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TagsidTag();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} name
 */
TagsidTag.prototype.name = undefined;

/**
 * @member {String} description
 */
TagsidTag.prototype.description = undefined;

